import React, { useRef } from 'react';

const CodeInput = ({ length = 6, value, onChange }) => {
  const inputsRef = useRef([]);

  // Converte la stringa in array con lunghezza fissa
  const valueArray = Array.from({ length }, (_, i) => value[i] || '');

  const handleChange = (e, index) => {
    const val = e.target.value;
    // Accetta solo numeri
    if (!/^\d*$/.test(val)) return;

    // Crea un nuovo array a partire dalla stringa corrente
    const newValueArr = [...valueArray];
    newValueArr[index] = val.slice(-1); // prendi solo l'ultimo carattere
    const newValue = newValueArr.join('');
    onChange(newValue);

    // Se è stato inserito un numero, sposta il focus sul campo successivo (se esiste)
    if (val && index < length - 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !valueArray[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  return (
    <div className="flex w-full space-x-2 md:space-x-3 justify-center">
      {Array.from({ length }).map((_, index) => {
        // Se il campo contiene un numero, il bordo sarà wild-ocean, altrimenti sarà grigio
        const inputClass = valueArray[index]
          ? 'border-wild-ocean'
          : 'border-gray-200';
        return (
          <input
            key={index}
            type="text"
            maxLength={1}
            value={valueArray[index]}
            onChange={(e) => handleChange(e, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            ref={(el) => (inputsRef.current[index] = el)}
            className={` w-10 h-10 md:w-14 md:h-14 border ${inputClass} rounded text-center text-xl focus:outline-none focus:border-green-advenutur`}
          />
        );
      })}
    </div>
  );
};

export default CodeInput;
